import React from 'react';
import { Image } from 'antd';
import { WEBSITE_URL } from '../../Helper';

const SpinWaitCustom = () => {
  return (
    <div className="Wait-spin-loader">
      <div className="show-loader">
        <div className="ajax-flipper-overlay"></div>
        <div className="ajax-flipper-container">
          <div className="ajax-flipper flip-animation">
            <Image
              src={`${WEBSITE_URL}/wp-content/uploads/2021/09/logo_tm.png`}
              className="ajax-flip-img"
              preview={false}
            />
          </div>
          <div className="ajax-flipper overlap-flip-animation">
            <Image
              src={`${WEBSITE_URL}/wp-content/uploads/2021/09/logo_tm.png`}
              className="ajax-flip-img rotate-180-y"
              preview={false}
            />
          </div>
        </div>
       
        <section className="loading-data">
          <div className="loading">
            <div className="loading__letter">P</div>
            <div className="loading__letter">l</div>
            <div className="loading__letter">e</div>
            <div className="loading__letter">a</div>
            <div className="loading__letter">s</div>
            <div className="loading__letter">e</div>
            <div className="loading__letter space-txt"></div>
            <div className="loading__letter">W</div>
            <div className="loading__letter">a</div>
            <div className="loading__letter">i</div>
            <div className="loading__letter">t</div>
            <div className="loading__letter">.</div>
            <div className="loading__letter">.</div>
            <div className="loading__letter">.</div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SpinWaitCustom;
